<main>

    <h2><span>404:</span> NOT FOUND</h2>
    
    <div>
        <p>the resource you're looking for is not here. Please go back <a href="/">home</a>.</p>
    </div>

</main>

<style>

    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    span {
        color: tomato;
    }

    main {
        font-family: 'Share Tech Mono', monospace;
        background: rgba(255, 255, 255, 0.4);
        padding: 1rem;
    }

    h2 {
        margin: 0 .5rem;
    }

    div {
        background: rgba(0, 0, 0, 0.6);
        color: white;
        padding: .5rem;
        margin: .25rem;
    }

    a {
        color: yellow;
    }

</style>
